// URL params are user-editable: cap accepted items so a crafted link can't
// balloon requests or filter-chip rendering
const MAX_ARRAY_PARAM_ITEMS = 100;

export const serializeArrayParam = (arr: string[] | undefined): string => {
  if (!arr?.length) return "";
  return arr.join(",");
};

export const deserializeArrayParam = (value: string): string[] | undefined => {
  if (!value) return undefined;
  const arr = value.split(",").filter(Boolean).slice(0, MAX_ARRAY_PARAM_ITEMS);
  return arr.length > 0 ? arr : undefined;
};

export const serializeObjectArrayParam = (
  arr: { id: string; name: string }[] | undefined
): string => {
  if (!arr?.length) return "";
  return JSON.stringify(arr);
};

const isIdNameItem = (
  item: unknown
): item is { id: string | number; name: string } => {
  if (typeof item !== "object" || item === null) return false;
  const record = item as Record<string, unknown>;
  return (
    (typeof record.id === "string" || typeof record.id === "number") &&
    typeof record.name === "string"
  );
};

export const deserializeObjectArrayParam = (
  value: string
): { id: string; name: string }[] | undefined => {
  if (!value) return undefined;
  try {
    const parsed: unknown = JSON.parse(value);
    if (Array.isArray(parsed)) {
      const valid = parsed
        .slice(0, MAX_ARRAY_PARAM_ITEMS)
        .filter(isIdNameItem)
        .map((item) => ({ id: String(item.id), name: item.name }));
      if (valid.length > 0) return valid;
    }
  } catch {
    // Invalid JSON, return undefined
  }
  return undefined;
};
